import { DataDisplayEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutMobileCommPositionMovementQuickInfo } from "./autogen/AutogenLayoutMobileCommPositionMovementQuickInfo";

export class MobileCommPositionMovementQuickInfo extends AutogenLayoutMobileCommPositionMovementQuickInfo {

    textboxMovementIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxMovementId.printableLabel.link = LayoutUrl.create(
            "lme/dispatch/OrderTabView",
            {
                mode: "update",
                key: event.rowData?.get("id"),
                orderId: event.rowData?.get("orders.id"),
            }
        );
    }
}
